import { PrefPermissionsProvider } from "@pepsico/pref-permissions";
import { Frame, type User } from "@pepsico/layout";

import type { UserRead } from "api/model";
import { useUser } from "components/UserProvider";
import {
  allPagePermissions,
  APP_TITLE,
  defaultPrefs,
  NON_PROD_URL_PREFIX,
} from "defs";

const toLayoutUser = (user?: UserRead): User | undefined => {
  if (!user) {
    return undefined;
  }

  return {
    displayName: user.name ?? user.email,
    is_superuser: user.is_superuser,
    is_verified: user.is_verified,
  };
};

const AppFrame: React.FC = () => {
  const { user } = useUser();

  return (
    <PrefPermissionsProvider
      allPagePermissions={allPagePermissions}
      defaultPrefs={defaultPrefs}
    >
      <Frame
        appTitle={APP_TITLE}
        nonProdUrlPrefix={NON_PROD_URL_PREFIX}
        user={toLayoutUser(user)}
      />
    </PrefPermissionsProvider>
  );
};

export default AppFrame;
